import {Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbPagination} from '@ng-bootstrap/ng-bootstrap';
import {WsLogService} from './ws-log.service';
import {WsLogPageData} from '../../../../generated-model/models';
import {PageResponse} from '../../../shared/commons/page-response';
import {ThaiDateTimePipe} from '../../../shared/commons/thai-datetime.pipe';
import {PageTitleComponent} from '../../../shared/commons/page-title/page-title.component';
import {PagesizeSelectComponent} from '../../../shared/components/pagesize-select/pagesize-select.component';
import {HttpClient} from '@angular/common/http';

type HttpStatusTone = 'success' | 'danger' | 'warn' | 'secondary';

@Component({
  selector: 'app-ws-log-list',
  standalone: true,
  imports: [FormsModule, NgbPagination, ThaiDateTimePipe, PageTitleComponent, PagesizeSelectComponent],
  templateUrl: './ws-log-list.component.html',
  styleUrl: './ws-log-list.component.scss'
})
export class WsLogListComponent implements OnInit {
  private readonly service = inject(WsLogService);
  private readonly http = inject(HttpClient);

  protected term = signal<string>('');
  protected responseCodeCategory = signal<string>('');
  protected apiDescMap = signal<Record<string, string>>({'auth': 'ตรวจสอบผู้ใช้งาน'});
  protected pageData = signal<PageResponse<WsLogPageData>>({
    page: {size: 20, number: 0}
  } as PageResponse<WsLogPageData>);

  ngOnInit(): void {
    this.loadApiDescriptions();
    this.search();
  }

  private loadApiDescriptions(): void {
    this.http.get<any>('/api/master/web-service-apis', {params: {size: 1000}}).subscribe({
      next: (res) => {
        const map: Record<string, string> = {'auth': 'ตรวจสอบผู้ใช้งาน'};
        (res.content ?? []).forEach((item: any) => {
          if (item.apiName && item.apiDescription) {
            map[item.apiName] = item.apiDescription;
          }
        });
        this.apiDescMap.set(map);
      }
    });
  }

  search(page: number = 1): void {
    const params: Record<string, string | number> = {
      page: page - 1,
      size: this.pageData().page.size,
      sort: 'logTime,desc'
    };
    if (this.term().trim()) {
      params['term'] = this.term().trim();
    }
    if (this.responseCodeCategory()) {
      params['responseCodeCategory'] = this.responseCodeCategory();
    }
    this.service.search(params).subscribe({
      next: (res) => this.pageData.set(res),
      error: (err) => console.error(err)
    });
  }

  reset(): void {
    this.term.set('');
    this.responseCodeCategory.set('');
    this.search();
  }

  protected statusTone(code: number | undefined): HttpStatusTone {
    if (!code) {
      return 'secondary';
    }
    if (code >= 200 && code < 300) {
      return 'success';
    }
    if (code >= 400 && code < 500) {
      return 'warn';
    }
    if (code >= 500) {
      return 'danger';
    }
    return 'secondary';
  }

  protected httpStatusText(code: number | undefined): string {
    if (!code) {
      return '-';
    }
    const texts: Record<number, string> = {
      200: 'OK', 201: 'Created', 204: 'No Content',
      301: 'Moved Permanently', 302: 'Found', 304: 'Not Modified',
      400: 'Bad Request', 401: 'Unauthorized', 403: 'Forbidden',
      404: 'Not Found', 405: 'Method Not Allowed', 409: 'Conflict',
      422: 'Unprocessable Entity', 429: 'Too Many Requests',
      500: 'Internal Server Error', 502: 'Bad Gateway', 503: 'Service Unavailable',
    };
    return `${code} ${texts[code] ?? ''}`.trim();
  }
}
